import axios from "axios";

axios.interceptors.request.use(
  (config) => {
    config.headers["Authorization"] = "Bearer baoneleuleu";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const request = ({
  method = "GET",
  url = "",
  data = null,
  params = null,
  callBack,
}) => {
  return axios({
    method: method,
    url: url,
    data: data,
    params,
    // ...(params ? { params: new URLSearchParams(params) } : {}),
  })
    .then(function (response) {
      return callBack("success", response);
    })
    .catch((error) => {
      return callBack("error", error);
    })
    .finally(() => {
      return callBack("finally", true);
    });
};

export default request;
